import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-semobold" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Account"),
    /*#__PURE__*/_createElementVNode("th", null, "Role"),
    /*#__PURE__*/_createElementVNode("th", null, "Created On"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, onMounted } from "vue";
import { customerStatusOptions } from "@/core/types/ShopTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerList',
  setup(__props) {

const isLoading = ref(false);
const data = ref([
  {
    id: 1,
    name: "John Doe",
    phone: "1234567890",
    email: "kay.wu@bacera.com",
    status: 0,
  },
  {
    id: 2,
    name: "John Doe",
    phone: "1234567890",
    email: "kay.wu@bacera.com",
    status: 1,
  },
  {
    id: 3,
    name: "John Doe",
    phone: "1234567890",
    email: "kay.wu@bacera.com",
    status: 2,
  },
  {
    id: 4,
    name: "John Doe",
    phone: "1234567890",
    email: "kay.wu@bacera.com",
    status: 3,
  },
]);
const tab = ref(customerStatusOptions[0].value);
const isTabActive = (_tab: any) => {
  return tab.value === _tab;
};

const changeTab = (_value: any) => {
  tab.value = _value;
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customerStatusOptions), (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item",
            key: tab.value
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link text-active-primary pb-2", { active: isTabActive(tab.value) }]),
              "data-bs-toggle": "tab",
              href: "#",
              onClick: ($event: any) => (changeTab(tab.value))
            }, _toDisplayString(tab.label), 11, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.phone), 1),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.address), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Approve")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Reject")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}
}

})